import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeaderContainer } from './Header.style';
import Logo from '../assets/images/HomeConfigureLogo.png';
import { useStores } from '../../../hooks/useStores';
import Button from '../Button';
import { observer } from 'mobx-react-lite';
function Header(param) {
    var height = param.height, _param_logo = param.logo, logo = _param_logo === void 0 ? Logo : _param_logo;
    var _authStore_loggedInUser;
    var authStore = useStores().authStore;
    return /*#__PURE__*/ _jsxs(HeaderContainer, {
        height: height,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "header-logo",
                children: /*#__PURE__*/ _jsx("img", {
                    src: logo,
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "header-right",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        children: [
                            "Hi, ",
                            (_authStore_loggedInUser = authStore.loggedInUser) === null || _authStore_loggedInUser === void 0 ? void 0 : _authStore_loggedInUser.username.split('@')[0]
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: function onClick() {
                            return authStore.logout();
                        },
                        children: "Logout"
                    })
                ]
            })
        ]
    });
}
export default observer(Header);
